// Трекер действий клиента: буфер + автоотправка пачками на бэкенд.
// POST /api/activity-logs/client/  (source='client' сервер ставит сам).
import { API_URL } from '../api';

const ENDPOINT = API_URL + '/api/activity-logs/client/';

const FLUSH_INTERVAL_MS = 8000;
const FLUSH_THRESHOLD   = 25;
const MAX_BATCH         = 100;

const SESSION_KEY = 'al_client_session_id';
function getSessionId() {
    try {
        let sid = sessionStorage.getItem(SESSION_KEY);
        if (!sid) {
            const raw = (window.crypto && window.crypto.randomUUID)
                ? window.crypto.randomUUID()
                : (String(Date.now()) + Math.random().toString(16).slice(2));
            sid = String(raw).replace(/-/g, '').slice(0, 32);
            sessionStorage.setItem(SESSION_KEY, sid);
        }
        return sid;
    } catch (e) { return 'nosession'; }
}

function getClientToken() {
    try { return localStorage.getItem('client_token'); } catch (e) { return null; }
}

let buffer = [];
let timer = null;
let enabled = true;
let inited = false;
let currentPath = (typeof window !== 'undefined') ? window.location.pathname : '';

export function setTrackerPath(path) { if (path) currentPath = path; }
export function setTrackerEnabled(v) { enabled = !!v; if (!v) buffer = []; }

// action — 'client.page_view' | 'client.click' | 'client.<область>.<действие>'
export function track(action, opts = {}) {
    try {
        if (!enabled || !action) return;
        buffer.push({
            action: String(action).slice(0, 128),
            title: opts.title ? String(opts.title).slice(0, 255) : '',
            module: opts.module || 'client_ui',
            level: opts.level || 'info',
            status: opts.status || 'success',
            path: opts.path || currentPath,
            ts: new Date().toISOString(),
            meta: (opts.meta && typeof opts.meta === 'object') ? opts.meta : {},
        });
        if (buffer.length >= FLUSH_THRESHOLD) flush();
        else scheduleFlush();
    } catch (e) { /* телеметрия не должна ломать UI */ }
}

function scheduleFlush() {
    if (timer) return;
    timer = setTimeout(() => { timer = null; flush(); }, FLUSH_INTERVAL_MS);
}

export function flush() {
    try {
        if (timer) { clearTimeout(timer); timer = null; }
        if (!buffer.length) return;

        const token = getClientToken();
        if (!token) { buffer = []; return; }   // не авторизован — не копим бесконечно

        const events = buffer.splice(0, MAX_BATCH);
        const payload = JSON.stringify({ session_id: getSessionId(), events });

        fetch(ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `ClientToken ${token}`,
            },
            body: payload,
            keepalive: true,
            credentials: 'omit',
        }).catch(() => { /* телеметрия не критична */ });
    } catch (e) { /* ignore */ }
}

// ── Глобальный автозахват кликов ──
function elementLabel(el) {
    const dt = el.getAttribute('data-track');
    if (dt) return dt.slice(0, 120);
    const aria = el.getAttribute('aria-label');
    if (aria) return aria.slice(0, 120);
    const title = el.getAttribute('title');
    if (title) return title.slice(0, 120);
    const text = (el.innerText || el.textContent || '').trim().replace(/\s+/g, ' ');
    if (text) return text.slice(0, 120);
    return el.tagName ? el.tagName.toLowerCase() : 'el';
}

function closestInteractive(node) {
    let el = node;
    for (let i = 0; el && i < 6; i++) {
        if (el.nodeType === 1) {
            const tag = el.tagName;
            const role = el.getAttribute ? el.getAttribute('role') : null;
            if ((el.hasAttribute && el.hasAttribute('data-track'))
                || tag === 'BUTTON' || tag === 'A' || role === 'button') {
                return el;
            }
        }
        el = el.parentElement;
    }
    return null;
}

function onGlobalClick(e) {
    try {
        const el = closestInteractive(e.target);
        if (!el) return;
        if (el.closest && el.closest('[data-track-ignore]')) return;

        const label = elementLabel(el);
        const meta = { tag: (el.tagName || '').toLowerCase(), label };

        const href = el.getAttribute && el.getAttribute('href');
        if (href) meta.href = String(href).slice(0, 200);
        const extra = el.getAttribute && el.getAttribute('data-track-meta');
        if (extra) { try { Object.assign(meta, JSON.parse(extra)); } catch (e) { /* ignore */ } }

        track('client.click', { title: `Клик: ${label}`, meta });
    } catch (e) { /* ignore */ }
}

export function initTracker() {
    if (inited || typeof window === 'undefined') return;
    inited = true;

    document.addEventListener('click', onGlobalClick, true);

    const onHide = () => flush();
    window.addEventListener('pagehide', onHide);
    window.addEventListener('beforeunload', onHide);
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') flush();
    });
}